import PropTypes from 'prop-types';
import React from 'react';

import styled from 'styled-components';
import { media } from '../../helpers';

import { colors } from '../../styles/colors/';

const StyledProgressBarContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
`;

const StyledProgressBarGrey = styled.span`
  height: 14px;
  width: 14px;
  background-color: ${colors['gray']['2']};
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
`;

const StyledProgressBarFill = styled.span`
  height: 14px;
  width: 14px;
  background-color: ${(props) => props.fillColor};
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
`;

const StyledSpan = styled.span`
  ${media.mobile`
    font-size: 16px;
    line-height: 24px;
  `};
`;

/**
 * Primary UI component for user interaction
 */
const ProgressBar = ({ stepsFilled, totalSteps, fillColor }) => {
  let filledSteps = Array.apply(null, { length: stepsFilled }).map(Number.call, Number);
  let unFilledSteps = Array.apply(null, {
    length: totalSteps - stepsFilled,
  }).map(Number.call, Number);

  const verbiage = `Step ${stepsFilled} of ${totalSteps}`;
  return (
    <StyledProgressBarContainer>
      {filledSteps.map((step, index) => {
        return <StyledProgressBarFill key={`filled_steps_${index}`} fillColor={fillColor} />;
      })}

      {unFilledSteps.map((step, index) => {
        return <StyledProgressBarGrey key={`unfilled_steps_${index}`} />;
      })}
      <StyledSpan>{verbiage}</StyledSpan>
    </StyledProgressBarContainer>
  );
};

ProgressBar.propTypes = {
  /**
   * ProgressBar contents
   */
  stepsFilled: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  fillColor: PropTypes.string,
};

ProgressBar.defaultProps = {
  fillColor: colors['indigo']['4'],
};

export { ProgressBar };
